import React, { useCallback, useEffect } from 'react'
import { getSelectGoodsCls as cls } from '../select-goods'
import { Empty } from 'antd'

import '../select-goods.scss'
import { observer } from 'mobx-react'
import Button from '@/components/button/button'
import { Expaned } from '@/components/layout/layout'
import Iconfont from '@/components/iconfont/iconfont'
import { selectGoodStore } from '../model'
import { Goods } from '@/model/types/goods'
import { layerManage } from '@/utils/layer'

interface SelectGoodsListProps {
    onSubmit: (good: Goods[]) => void
    confirmOnEnter?: boolean
}

const SelectGoodsList: React.FC<SelectGoodsListProps> = observer(props => {
    const { confirmOnEnter, onSubmit } = props

    const onReduce = (id: number) => {
        selectGoodStore.setSelectKey(selectGoodStore.selectKey.filter(l => l !== id))
        selectGoodStore.setSelectList(selectGoodStore.selectList.filter(l => l.id !== id))
    }

    const handleConfirm = useCallback(() => {
        if (!selectGoodStore.selectList.length) {
            return
        }

        selectGoodStore.setInitSelectKey(selectGoodStore.selectKey)
        selectGoodStore.setInitSelectList(selectGoodStore.selectList)
        selectGoodStore.setActiveId(void 0)
        selectGoodStore.setSecondId(0)

        onSubmit(selectGoodStore.selectList)
        layerManage.pop()
    }, [onSubmit])

    useEffect(() => {
        if (!confirmOnEnter) {
            return
        }

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key !== 'Enter') {
                return
            }

            const target = event.target
            if (target instanceof HTMLInputElement && target.type !== 'checkbox' && target.type !== 'radio') {
                return
            }

            if (
                target instanceof HTMLTextAreaElement ||
                target instanceof HTMLSelectElement ||
                target instanceof HTMLAnchorElement ||
                (target instanceof HTMLElement && target.isContentEditable)
            ) {
                return
            }

            event.preventDefault()
            event.stopPropagation()

            if (event.repeat || event.isComposing || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) {
                return
            }

            handleConfirm()
        }

        window.addEventListener('keydown', handleKeyDown, true)

        return () => window.removeEventListener('keydown', handleKeyDown, true)
    }, [confirmOnEnter, handleConfirm])

    return (
        <div className={cls('list')}>
            {selectGoodStore.selectList.length ? (
                <>
                    <div className={cls('list', 'top')}>
                        已选择
                        <div data-margin-h-4 className="them-color">
                            {selectGoodStore.selectList.length}
                        </div>
                        个商品
                    </div>
                    <Expaned data-overflow-auto data-padding-bottom-10>
                        {selectGoodStore.selectList.map(list => (
                            <div key={list.id} className={cls('list', 'item')}>
                                <div className="txt">{list.name}</div>
                                <div data-cursor-pointer>
                                    <Iconfont
                                        name="icon6yichu-20"
                                        size={20}
                                        onClick={() => {
                                            onReduce(list.id)
                                        }}
                                    />
                                </div>
                            </div>
                        ))}
                    </Expaned>
                    <div className={cls('list', 'bottom')}>
                        <Button types="default" onClick={handleConfirm}>
                            确认
                        </Button>
                    </div>
                </>
            ) : (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暂无选择商品" />
            )}
        </div>
    )
})

export default SelectGoodsList
